import { cn } from '~/lib'

type ListingFeaturedProps = {
  className?: string
}

export default function ListingFeatured({ className }: ListingFeaturedProps) {
  return (
    <svg viewBox="0 0 248 236" className={cn('-mt-0.5 h-6 w-6', className)}>
      <path
        className="fill-amber-400 stroke-amber-400"
        d="M124,27.1146175 L154.237255,88.3819886 L221.849813,98.2066683 L172.924907,145.896666 L184.47451,213.236023 L124,181.442691 L63.5254895,213.236023 L75.0750933,145.896666 L26.1501866,98.2066683 L93.7627448,88.3819886 L124,27.1146175 Z"
        strokeWidth="24"
      />
    </svg>
  )
}
